import React, { useEffect } from 'react';
import BrushIcon from '@mui/icons-material/Brush';
import DeleteIcon from '@mui/icons-material/Delete';
import PanToolIcon from '@mui/icons-material/PanTool';
import {IconButton, Box, Tooltip} from '@mui/material';
import { useMapContext } from '../../contexts/MapContext';
import {useLIDContext} from "../../contexts/LIDContext";



const BrushEraserToolbar = () => {
    const {
        planIsRunning,
        setEnableLIDpanel,
        editMode,
        brushMode,
        setBrushMode,
        eraserMode,
        setEraserMode,
        handMode,
        setHandMode,
        setPolygonMode,
        setAddGIFromBrush,
        setLIDMode,
        outFileExists,
      setEditMode,
    } = useMapContext();
    const {
      setBrushedSubcatchments,
      brushedSubcatchments,
    } = useLIDContext();

    const handleBrushClick = () => {
      console.log("handleBrushClick");
        if (!editMode) setEditMode(true);
        setEnableLIDpanel(true);
        setBrushMode(true);
        setEraserMode(false);
        setHandMode(false);
        setPolygonMode(false);
        setAddGIFromBrush(true);
        setLIDMode(true);
    };

    const handleEraserClick = () => {
        setAddGIFromBrush(true);
        if (!editMode) setEditMode(true);
        setBrushMode(false);
        setEraserMode(true);
        setHandMode(false);
        setPolygonMode(false);
    };

    const handleHandClick = () => {
      setBrushedSubcatchments(new Set());
      setHandMode(true);
      setAddGIFromBrush(false);
      setEditMode(false);
      setBrushMode(false);
      setEraserMode(false);
      setPolygonMode(false);
    };

    useEffect(() => {
        if (eraserMode && brushedSubcatchments.size === 0) {
            handleHandClick();
        }
    }, [eraserMode, brushedSubcatchments]);

    if (planIsRunning || outFileExists) return null;

    return (
        <Box
            sx={{
                position: 'absolute',
                top: '30px',
                left: '15px',
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                zIndex: 1100,
                backgroundColor: '#282828',
                borderRadius: '22px',
                padding: "3px",
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#444',
                    borderRadius: '22px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'space-between',
                    height: ((brushMode && brushedSubcatchments.size !== 0) || eraserMode) ? '80px' : '40px',
                    transition: "height 0.2s ease-in-out",
                }}
            >
                <Tooltip title="Brush Selection">
                    <IconButton
                        onClick={handleBrushClick}
                        sx={{
                            backgroundColor: brushMode ? '#1E90FF' : '#444',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: brushMode ? '#1E90FF' : '#555',
                            },
                        }}
                    >
                        <BrushIcon />
                    </IconButton>
                </Tooltip>
                {((brushMode && brushedSubcatchments.size !== 0) || eraserMode) && (
                    <Tooltip title="Eraser">
                    <span>
                    <IconButton
                        onClick={handleEraserClick}
                        onDoubleClick={() => {setBrushedSubcatchments(new Set())}}
                        sx={{
                            marginTop: '3px',
                            backgroundColor: eraserMode ? '#1E90FF' : '#444',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: eraserMode ? '#1E90FF' : '#555',
                            },
                        }}
                        disabled={brushedSubcatchments.size === 0}
                    >
                      <DeleteIcon />
                    </IconButton>
                      </span>
                    </Tooltip>
                )}
            </Box>
          <Tooltip title="Pan">
            <IconButton
              onClick={handleHandClick}
              sx={{
                backgroundColor: handMode ? '#1E90FF' : '#444',
                color: 'white',
                '&:hover': {
                  backgroundColor: handMode ? '#1E90FF' : '#555',
                },
              }}
            >
              <PanToolIcon />
            </IconButton>
          </Tooltip>
        </Box>
    );
};

export default BrushEraserToolbar;
